module.exports = __webpack_public_path__ + "img/city16.6c42c010.jpg";